<template>
  <div class="details-table-row">
    <slot></slot>
  </div>
</template>

<script>
  export default {
    name: "table-col",
  }
</script>

<style scoped>
  .details-table-row {
    /*flex-shrink:0;*/
    /*display: table-cell;*/
    /*table-layout: fixed;*/
    border-right: 1px solid #E5E5E5;
    border-bottom: 1px solid #E5E5E5;
    font-size:14px;
    color: rgba(51,51,51,1);
    /*flex: 1;*/
    vertical-align: middle;
  }

</style>
